class EmployeeSubscribedToMcpBenefitSystemNotificationPayload {
  constructor(systemNotificationPayloadData = {}) {
    this.minimumContractPeriod = systemNotificationPayloadData.minimum_contract_period || "";
    this.minimumContractPeriodExpiration = systemNotificationPayloadData.minimum_contract_period_expiration || "";
  }
}

export default EmployeeSubscribedToMcpBenefitSystemNotificationPayload;
